<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="地图配置" :expand="true">
      <t-form-item label="地图缩放级别">
        <t-input-number v-model="attribute.zoom" :min="3" size="large" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="中心坐标X轴">
        <t-input-number v-model="attribute.centerx" :step="0.000001" size="large" :decimal-places="6" />
      </t-form-item>
      <t-form-item label="中心坐标y轴">
        <t-input-number v-model="attribute.centery" :step="0.000001" size="large" :decimal-places="6" />
      </t-form-item>
    </e-collapse>
    <t-form-item label="显示GPS">
      <t-switch v-model="attribute.showGPS" size="small" :label="['开', '关']" />
    </t-form-item>
      <e-collapse title="字体设置" :expand="true">
        <t-form-item label="字体颜色">
          <t-color-picker
            size="small"
            :colorModes="['monochrome']"
            format="RGBA"
            enableAlpha
            v-model="attribute.textColor"
          />
        </t-form-item>
        <t-form-item label="字体样式">
          <t-radio-group size="small" v-model="attribute.fontStyle">
            <t-radio-button value="normal">正常</t-radio-button>
            <t-radio-button value="italic">斜体</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="加粗">
          <t-radio-group size="small" v-model="attribute.fontWeight">
            <t-radio-button value="normal">正常</t-radio-button>
            <t-radio-button value="bold">加粗</t-radio-button>
            <t-radio-button value="lighter">更细</t-radio-button>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="字体">
          <t-select size="small" v-model="attribute.fontFamily">
            <t-option
              v-for="item in textFamilyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </t-select>
        </t-form-item>
        <t-form-item label="字体大小">
          <t-input-number
            size="small"
            :min="0"
            :max="9999"
            v-model="attribute.fontSize"
            :decimal-places="0"
          />
        </t-form-item>
      </e-collapse>
    <e-collapse title="图片配置" :expand="true">
      <t-form-item label="图库选择">
          <div @click="showGallery" style="width: 168px; height: 160px">
            <t-image style="width: 100%;height: 100%;background: none" :src="attribute.url? fileUrl + attribute.url:require('@/assets/logo.png')" fit="fill"/>
          </div>
        </t-form-item>
      <t-form-item label="图片宽度">
          <t-input-number
            size="small"
            :min="0"
            :max="9999"
            v-model="attribute.width"
            :decimal-places="0"
          />
        </t-form-item>
        <t-form-item label="图片高度">
          <t-input-number
            size="small"
            :min="0"
            :max="9999"
            v-model="attribute.height"
            :decimal-places="0"
          />
        </t-form-item>
        <t-form-item label="填充方式">
          <t-select
            v-model="attribute.fit"
            placeholder="请选择填充方式"
            size="small"
          >
            <t-option label="fill" value="fill" />
            <t-option label="contain" value="contain" />
            <t-option label="cover" value="cover" />
            <t-option label="none" value="none" />
            <t-option label="scale-down" value="scale-down" />
          </t-select>
        </t-form-item>
        <t-form-item label="自动旋转">
          <t-radio-group v-model="attribute.autoRotate" size="small">
            <t-radio :value="true">开启</t-radio>
            <t-radio :value="false">关闭</t-radio>
          </t-radio-group>
        </t-form-item>
        <t-form-item label="自旋时长(s)">
          <t-input-number
            :min="1"
            :max="60"
            v-model="attribute.rotateDuration"
            size="small"
            :decimal-places="0"
          />
        </t-form-item>
        <t-form-item label="背景颜色">
          <t-color-picker
            :colorModes="['monochrome']"
            format="RGBA"
            v-model="attribute.imgBgColor"
            enableAlpha
            size="small"
          />
        </t-form-item>
    </e-collapse>
  </t-form>
  <gallery ref="gallery" @confirmCheck="confirmCheck"/>
</template>
  
<script>
import {fileUrl} from '/env'
import CptData from '@/components/element/options/comp/cpt-data'
import Gallery from "@/components/designer/gallery";
export default {
  name: "cpt-text-option",
  components: {CptData,Gallery },
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  data() {
    return {
      fileUrl
    }
  },
  mounted() {
  },
  created() {
     this.textFamilyList = require("@/assets/font/font-list");
  },
  methods: {
    showGallery(){
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl){
      this.attribute.url = fileUrl
    }
  }
}
</script>
  
<style scoped></style>
  